import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStateStrict } from "@ajayvikas/react-common";
import React from "react";
import { PopOver } from "../poppers/PopOver";
import { Caret } from "../icons/Caret";
import { DateInput } from "./DateInput";
import Calendar from "react-calendar";
import { isDateEqual } from "@ajayvikas/common-utils";
import cls from "../react-select/combo-box.module.scss";
const INPUT_STYLE = {
    backgroundColor: "transparent", outline: "none", padding: 0,
    border: "none", width: "100%",
    lineHeight: "inherit",
    // width: "5.25rem",
    // position: "absolute", top: 0, left: 0, 
    // height: "100%",
    maxWidth: "100%"
};
export const DatePicker = React.forwardRef((props, forwardRef) => {
    const { onChange, value, className, style, __keepOpen } = props;
    const [visible, _setVisible] = useStateStrict(false);
    const [transientValue, setTransientValue] = useStateStrict(undefined, isDateEqual);
    const [inputRef, setInputRef] = React.useState(null);
    const setVisibleTrue = () => {
        _setVisible(true);
    };
    const setVisibleFalse = () => {
        _setVisible(false);
        setTransientValue(undefined);
    };
    const onControlMouseDown = (e) => {
        if (e.button !== 0)
            return;
        if (e.defaultPrevented)
            return;
        const input = inputRef?.querySelector("input");
        if (e.target === input)
            return;
        e.preventDefault();
        input?.focus();
        const clear = inputRef?.querySelector("[data-id='clear']");
        if (clear?.contains(e.target))
            return;
        visible ? setVisibleFalse() : setVisibleTrue();
    };
    const onPopperMouseDown = (e) => {
        e.preventDefault();
    };
    const onBlur = () => {
        if (__keepOpen)
            return;
        setVisibleFalse();
    };
    const onKeyDown = (e) => {
        if (e.key === "ArrowDown") {
            if (!visible) {
                setVisibleTrue();
                e.preventDefault();
            }
        }
        else if (e.key === "Escape") {
            if (visible)
                setVisibleFalse();
        }
    };
    const onCalendarChange = (value) => {
        setVisibleFalse();
        props.onChange?.(value);
    };
    const onInput = (value) => {
        setTransientValue(value);
    };
    return _jsxs(_Fragment, { children: [_jsx("span", { ref: setInputRef, style: { ...style, display: "inline-flex" }, className: className, onMouseDown: onControlMouseDown, children: _jsxs("div", { className: cls.controlWrapper, children: [_jsx(DateInput, { ref: forwardRef, style: INPUT_STYLE, className: "picker-inner-input no-style", onBlur: onBlur, onKeyDown: onKeyDown, value: value, onChange: onChange, onInput: onInput }), _jsx(Caret, { size: ".75em", flip: visible })] }) }), _jsx(PopOver, { referenceElement: inputRef, visible: visible, width: "fit-content", purpose: "date-picker", children: _jsx("div", { className: cls.datePicker, onMouseDown: onPopperMouseDown, children: _jsx(Calendar, { onChange: onCalendarChange, value: transientValue || props.value }) }) })] });
});
